import React from 'react';
import TypographySkeleton from '../Skeleton/Typography';
import { Select, OutlinedInput, MenuItem } from './styles';
export default function MonthPickerSkeleton() {
  var value = 'skeleton';
  return /*#__PURE__*/React.createElement(Select, {
    disabled: true,
    value: value,
    input: /*#__PURE__*/React.createElement(OutlinedInput, {
      margin: "dense",
      labelWidth: 0
    })
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: value
  }, /*#__PURE__*/React.createElement(TypographySkeleton, {
    width: 90
  })));
}